/* import __COLOCATED_TEMPLATE__ from './charges.hbs'; */
import Component from '@glimmer/component';

export default class SiteBillingAccountHistoryCellsCharges extends Component {
  get chargeValue() {
    const item = this.args.item;

    switch (item.constructor.modelName) {
      case 'appointment':
      case 'group-appointment':
        return item.fee || item.uninvoicedFee || 0;
      case 'invoice-item':
        return item.price || 0;
      case 'payment':
        return 0;
      default:
        return null;
    }
  }
}
